import { z } from 'zod';

export const CreateSavingsGoalSchema = z
  .object({
    name: z.string().min(1, 'Goal name is required'),
    categoryType: z.enum(['safety_net', 'travel', 'transportation', 'housing', 'other']),
    targetAmount: z.number().positive('Target amount must be greater than zero'),
    targetDate: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
    priority: z.enum(['high', 'medium', 'low']),
    monthlyTarget: z.number().positive().optional(),
    startingAmount: z.number().min(0, 'Starting amount cannot be negative').optional().default(0),
  })
  .refine((data) => (data.startingAmount ?? 0) <= data.targetAmount, {
    message: 'Starting amount cannot exceed target amount',
    path: ['startingAmount'],
  });

export function validateCreateSavingsGoal(input: unknown) {
  return CreateSavingsGoalSchema.safeParse(input);
}

export const AddProgressSchema = z.object({
  goalId: z.string().uuid(),
  amount: z.number().positive(),
  contributionDate: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
});
